import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block"
      data-product-shop
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={video.poster}
          alt={video.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${video.title} - 棒棒TV高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="w-full">
            <p className="text-white text-xs line-clamp-2 mb-2">{video.description}</p>
            <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-500 text-white text-xs rounded-full whitespace-nowrap">
              <i className="ri-play-fill"></i>立即观看
            </span>
          </div>
        </div>

        {video.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-[10px] font-bold rounded whitespace-nowrap">
            HOT
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-secondary-500 text-white text-[10px] font-bold rounded whitespace-nowrap">
            NEW
          </span>
        )}
        {!video.isHot && !video.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-background-900/70 text-foreground-200 text-[10px] rounded whitespace-nowrap">
            {video.rating}
          </span>
        )}

        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/80 text-foreground-200 text-[10px] rounded whitespace-nowrap">
          {video.updateInfo}
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-500 transition-colors line-clamp-1">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{video.category}</span>
        <span>·</span>
        <span>{video.year}</span>
        <span>·</span>
        <span className="text-accent-400 flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating}
        </span>
      </div>
    </Link>
  );
}